import { Box, Typography } from "@mui/material";
import { invoiceEditorInnerBorder } from "../../../../ui/invoiceEditorSectionSurface";

export const TableHeader = () => {
  return (
    <Box
      sx={{
        p: 2,
        borderBottom: invoiceEditorInnerBorder,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: "bold", color: "text.primary" }}>
        Service Items
      </Typography>
    </Box>
  );
};
